import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';

import { metaPixelPageView } from '../plugins/meta-pixel-plugin';
import { trackStoreEvent } from '../store-events/store-events';

/** Telas do marketplace (não são de uma loja): não contam para o pixel de ninguém. */
const MARKETPLACE_PATHS = [
  '/',
  '/search',
  '/profile',
  '/indicacao',
  '/sentry-test',
  '/error-boundary-test',
];

/**
 * PageView em toda troca de página da loja (PRAT-83). O mesmo id vai para o
 * Pixel (eventID) e para a API da pratiGO, que repassa à API de Conversões da
 * Meta — a Meta conta a página uma vez só.
 */
export function MetaPageViewTracker({ slug }: { slug: string }) {
  const [location] = useLocation();
  const last = useRef('');

  useEffect(() => {
    if (!slug || MARKETPLACE_PATHS.includes(location)) return;
    // StrictMode roda o efeito duas vezes: a mesma página não conta de novo.
    const key = `${slug}|${location}`;
    if (last.current === key) return;
    last.current = key;

    const eventId = trackStoreEvent('page_view', { slug });
    metaPixelPageView(eventId);
  }, [location, slug]);

  return null;
}
